// src/services/userService.js
import apiService from './api';

const userService = {
  // Get user profile by ID
  getUserProfile: async (userId) => {
    try {
      return await apiService.get(`/users/${userId}`);
    } catch (error) {
      throw error;
    }
  },

  // Get all authors/users
  getAuthors: async () => {
    try {
      return await apiService.get('/users');
    } catch (error) {
      throw error;
    }
  },

  // Get suggested users to follow
  getSuggestedUsers: async () => {
    try {
      return await apiService.get('/users/suggestions');
    } catch (error) {
      throw error;
    }
  },

  // Search users
  searchUsers: async (query) => {
    try {
      return await apiService.get('/users/search', { q: query });
    } catch (error) {
      throw error;
    }
  },

  // Follow a user
  followUser: async (userId) => {
    try {
      return await apiService.post('/followers', { userId });
    } catch (error) {
      throw error;
    }
  },

  // Unfollow a user
  unfollowUser: async (userId) => {
    try {
      return await apiService.delete(`/followers/${userId}`);
    } catch (error) {
      throw error;
    }
  },

  // Check if following a user
  checkFollowStatus: async (userId) => {
    try {
      return await apiService.get(`/followers/check/${userId}`);
    } catch (error) {
      throw error;
    }
  },

  // Get user's followers
  getFollowers: async (userId) => {
    try {
      return await apiService.get(`/followers/${userId}`);
    } catch (error) {
      throw error;
    }
  },

  // Get users followed by a user
  getFollowing: async (userId) => {
    try {
      return await apiService.get(`/followers/${userId}/following`);
    } catch (error) {
      throw error;
    }
  },

  // Get pending follow requests
  getFollowRequests: async () => {
    try {
      return await apiService.get('/followers/requests');
    } catch (error) {
      throw error;
    }
  },

  // Accept a follow request
  acceptFollowRequest: async (followerId) => {
    try {
      return await apiService.patch(`/followers/${followerId}/accept`);
    } catch (error) {
      throw error;
    }
  },

  // Reject a follow request
  rejectFollowRequest: async (followerId) => {
    try {
      return await apiService.delete(`/followers/${followerId}/reject`);
    } catch (error) {
      throw error;
    }
  }
};

export default userService;